import { useDispatch } from "react-redux";
import styles from "./Setting.module.scss";
import { useEffect, useState } from "react";
import { userDetails } from "reducer/usersSlice";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { getMailForPasswordReset } from "reducer/authSlice";

const Setting = () => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { isReady, errors },
  } = useForm({});

  const [userDetailsData, setuserDetailsData] = useState({});
  useEffect(() => {
    fetchDtata();
  }, []);
  const fetchDtata = async () => {
    try {
      const res = await dispatch(userDetails());
      setuserDetailsData(res.payload.data);
    } catch (error) {
      console.log(error);
    }
  };

  const submitHandler = async (data) => {
    try {
      console.log(data);
      const status = await dispatch(getMailForPasswordReset(data)).unwrap();
      if (status === true) {
        toast.success("Reset link sent to your email successfully!");
      } else {
        console.log("Something went wrong");
        toast.error("Failed to send reset link. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <main className={styles.setting}>
      <section className={styles.settinghero}>
        <div className={styles.card}>
          <h3>Profile Photo</h3>
          <img
            className={styles.profileImage}
            src="data:image/jpeg;base64,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"
            alt="Profile"
          />
        </div>

        <div className={styles.card}>
          <h3>Personal Information</h3>
          <div className={styles.grid}>
            <div className={styles.formGroup}>
              <label>First Name</label>
              <input
                type="text"
                defaultValue={userDetailsData?.firstName}
                disabled
              />
            </div>
            <div className={styles.formGroup}>
              <label>Last Name</label>
              <input
                type="text"
                defaultValue={userDetailsData?.lastName}
                disabled
              />
            </div>
          </div>
          <div className={styles.formGroup}>
            <label>Email Address</label>
            <input
              type="email"
              defaultValue={userDetailsData?.email}
              disabled
            />
          </div>
        </div>

        <form className={styles.card} onSubmit={handleSubmit(submitHandler)}>
          <h3 className={styles.heading}>Security Settings</h3>
          <p className={styles.subHeading}>Reset Password</p>
          <p className={styles.note}>
            No worries, we’ve got you—reset your password in a few steps!
          </p>
          <div className={styles.formGroup}>
            <label>Email ID</label>
            <input
              type="email"
              placeholder="Enter email ID"
              {...register("email")}
            />
          </div>
          <button className={styles.button} type="submit">
            Send Link
          </button>
        </form>
      </section>
    </main>
  );
};

export default Setting;
